import React from 'react';
const common = require('../../common/common');
const env = require("../../../config.js").default;

class ErrorReload extends React.Component {
  componentDidMount(){
    document.title = env.APP_NAME;
  }
  componentWillMount(){
    document.getElementById('body').className='content_page';
  }
  render(props){
    setTimeout(function(){window.location.reload()}, 60000)
    return (
        <div className="content_testo tab-content">
					<div id="content-core">
						<div className="row" style={{alignItems: "center", height: "calc(100vh - var(--header-height) - var(--footer-height))"}}>
							<div className="col-xl-12 text-center content_error">
								<h1 className="animated fadeInUp delay-03s">
                  {common.getTrad("Errore")}
                </h1>
								<h3 className="animated fadeInUp delay-06s">
                  {common.getTrad("Il servizio non è al momento disponibile")}
                </h3>
								<br/>
								<h3 className="animated fadeInUp delay-09s">
									<a href=".">
                    <i className="fas fa-sync-alt fa-spin"></i>&nbsp;
                    <b>{common.getTrad("Prova a ricaricare la pagina")}</b>
                  </a>
                </h3>
 							</div>
						</div>
					</div>
        </div>
    )
  }
}

export default ErrorReload;
